
import React from 'react';
import {  minspeed, maxspeed,avgspeed  } from "../../common/svg";
import SecureImage from "../../components/BucketImage/Image";
interface VehicleStats {
  startingOdo: number;
  finalOdo: number;
  avgMileage: number;
  fuelConsumption: number;
  totalDistance: number;
  currentFuelLevel: number;
  minSpeed: number;
  maxSpeed: number;
  avgSpeed: number;
  days: number;
  hours: number;
  minutes: number;
}

const Vehicleroute: React.FC = () => {
  const stats: VehicleStats = {
    startingOdo: 6473882,
    finalOdo: 6473882,
    avgMileage: 11,
    fuelConsumption: 45,
    totalDistance: 1464,
    currentFuelLevel: 450,
    minSpeed: 40,
    maxSpeed: 95,
    avgSpeed: 63,
    days: 3,
    hours: 11,
    minutes: 50
  };

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-10 gap-20 mr-10">
        {/* Ideal Time */}
        <div className=" w-[160px] h-[70px] rounded-[20px] border border-[#EAEAEA] relative right-[130px]">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-4 ml-4">Ideal Time</span>
          <div className="flex items-center">   
            <SecureImage
              
              fileKey={minspeed}
              alt="Over Speed"
              width="27px"
            />
            <span className="text-[16px] text-[#282828] font-[600] font-poppins ml-6">04.23 Hrs</span>
          </div>
          <p className="text-[12px] text-gray-500 ml-[50px]">Stoppages 206</p>
        </div>

        {/* Parking Time */}
        <div className=" w-[160px] h-[70px] rounded-[20px] m1-20 mr-[50px] border border-[#EAEAEA] relative right-[20px]">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 ml-4">Parking Time</span>
          <div className="flex items-center">
            <SecureImage
              
              fileKey={avgspeed}
              alt="Over Speed"
              width="27px"
            />
            <span className="text-[16px] text-[#282828] font-[600] font-poppins ml-6">04.23 Hrs</span>
          </div>
          <p className="text-[12px] text-gray-500 ml-[50px]">Stoppages 206</p>
        </div>

        {/* Over Speed */}
        <div className="bg-white w-[160px] h-[70px] rounded-[20px] border border-[#EAEAEA] ml-[200px] relative right-[120px]">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 ml-4">Over Speed</span>
          <div className="flex items-center">
            <SecureImage
              
              fileKey={maxspeed}
              alt="Over Speed"
              width="27px"
            />
            <span className="text-[16px] text-[#282828] font-[600] font-poppins ml-6">04.23 Hrs</span>
          </div>
          <p className="text-[12px] text-gray-500 ml-20">80 Kmph</p>
        </div>
      </div>
    </div>
  );
};

export default Vehicleroute;
